// Module
var code = "<template> <require from=\"./dropdown.scss\"></require> <slot></slot> </template> ";
// Exports
module.exports = code;